<template>
  <div class="sportmaster-profile">
    <ul class="profile__dropdown-list">
      <template v-if="currentUser.position">
        <li v-if="userInfo">
          <div class="profile__dropdown-title mt0">
            {{ `${userInfo.first_name} ${userInfo.last_name}` }}
          </div>
          <div class="profile__dropdown-subtitle">
            {{ roleName(userInfo.role) }}
          </div>

          <div class="sportmaster-profile__departments">
            <div
              v-for="item in userInfo.departments"
              :key="item.id"
              class="sportmaster-profile__department"
            >
              {{ item.name }}
            </div>
          </div>
        </li>
        <li v-else class="profile__dropdown-title mt0">
          {{ currentUser.position }}
        </li>
      </template>
    </ul>

    <ul class="profile__dropdown-list">
      <router-link
        v-if="isShowSettingsShopLink"
        tag="li"
        :to="{ name: 'profile-shop' }"
        class="profile__dropdown-item"
      >
        <i class="icon icon-gear"></i>
        <span>{{ $tr('profileMenu.settingsShop.link') }}</span>
      </router-link>
    </ul>

    <div class="profile__divider"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { STORE_PREFIX } from '@/process/sportmaster/constants';

export default {
  props: {
    currentUser: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(`${STORE_PREFIX}User`, ['userInfo', 'userInfoLoaded']),

    ...mapGetters(`${STORE_PREFIX}User`, ['getSportMasterRole']),

    isShowSettingsShopLink() {
      if (
        this.getSportMasterRole === 'admin_resercher' ||
        this.getSportMasterRole === 'shop_director'
      ) {
        return true;
      }

      return false;
    }
  },

  async created() {
    if (!this.userInfoLoaded) {
      await this.fetchUserInfo();
    }
  },

  methods: {
    ...mapActions(`${STORE_PREFIX}User`, ['fetchUserInfo']),

    roleName(role) {
      switch (role) {
        case 'admin_resercher':
          return 'Администратор';
        case 'resercher':
          return 'Менеджер по персоналу';
        case 'security':
          return 'Служба безопасности';
        case 'shop_director':
          return 'Директор магазина';
        case 'hr':
          return 'Отдел кадров';
        default:
          return 'Пользователь';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sportmaster-profile {
  @media screen and (max-width: 992px) {
    font-size: 1.55em;

    ::v-deep {
      .profile__dropdown-item i {
        font-size: 1.1em;
        margin-top: 2px;
      }
    }
  }

  &__departments {
    max-height: 250px;
    overflow: auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  &__department {
    display: inline-block;
    background: $green;
    padding: 2px 7px;
    border-radius: 2px;
    color: $white;
    margin-bottom: 3px;
    margin-right: 3px;
    font-size: 12px;
  }
}
</style>
